import AnyActivity from './AnyActivity';

export default AnyActivity;
